import { generateUUID } from '@app/lib/utility/helper';

// ── PixelFrame ───────────────────────────────────────────────────────────────
// A single frame in the animation.  The `pixels` field holds the flattened
// composite of all visible layers – kept for export, thumbnails, and collab.
// Per-layer pixel data lives in FrameState.cels, keyed by `frameId|layerId`.
export interface PixelFrame {
  id: string;
  pixels: string[][];   // composite (all layers merged) – for display & export
}

export function createBlankFrame(width: number, height: number, id?: string): PixelFrame {
  return {
    id: id ?? generateUUID(),
    pixels: Array.from({ length: height }, () => Array(width).fill('#00000000')),
  };
}

// ── Cel ──────────────────────────────────────────────────────────────────────
// The pixel content of one layer on one frame.
// Map key in FrameState.cels = `${frameId}|${layerId}`.
export type CelPixels = string[][];

export function celKey(frameId: string, layerId: string): string {
  return `${frameId}|${layerId}`;
}
